// extracted by mini-css-extract-plugin
export var editButton = "_mn-0";